import { PropsWithChildren } from "react"
import { GrowthBookProvider as Provider } from "@growthbook/growthbook-react"

import { isBrowser } from "../ssg-utils"

import { growthBook } from "./growthBook"

export function GrowthBookProvider({ children }: PropsWithChildren) {
    if (!isBrowser()) {
        return <>{children}</>
    }
    return <Provider growthbook={growthBook}>{children}</Provider>
}
